import { render, staticRenderFns } from "./EditThesisList.vue?vue&type=template&id=5c658563"
import script from "./EditThesisList.vue?vue&type=script&lang=js"
export * from "./EditThesisList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports